import graphql__b40200e610dd69d51294 from "./__generated__/ContributionsListNavigationWithFilters_participativeModule.graphql.js";import { Suspense, useState, useEffect } from "react";
import { graphql, useFragment } from "react-relay";

import ContributionsListFilters from "./ContributionsListFilters";
import { BoxSpinner } from "../../Utils/Spinner";
import ContributionsListNavigation from "./ContributionsListNavigation";
import { useStickyElementsHeight } from "../../Utils/StickyElementsHeight";
import { ContributionsListWithNavigationFragment_participativeModule } from "./ContributionsListWithNavigationFragment";
import { useFormatMessage } from "../../Intl/Context";
import { defineMessages } from "react-intl";
import { useResponsiveFlag } from "../../Utils/ResponsiveQueries";
import { checkCssIsDisabled } from "../../Utils/checkCssIsDisabled";

// Allows removing the 20px margin above the navigation when we calculate the height of
// the navigation container.
//
const NAVIGATION_TOP_MARGIN = 20;

// Allows for keeping a small 10px gutter above the navigation when it's sticky
// positionned so its top botder are not collapsed with the sticky navigation bottom one.
//
const NAVIGATION_STICKY_TOP_OFFSET = 10;

const ContributionsListNavigationWithFilters = ({ sticky = true, ...props }) => {
  const participativeModule = useFragment(
    ContributionsListNavigationWithFilters_participativeModule,
    props.participativeModule
  );

  const [isSticky, setIsSticky] = useState(sticky);
  const [container, setContainer] = useState();

  const { isDesktop } = useResponsiveFlag();

  const stickyElementsHeight = useStickyElementsHeight();
  const containerHeight = isDesktop
    ? window.innerHeight - stickyElementsHeight - NAVIGATION_TOP_MARGIN
    : "auto";

  const style = isSticky
    ? {
        top: stickyElementsHeight + NAVIGATION_STICKY_TOP_OFFSET,
        height: containerHeight,
        overflow: "auto"
      }
    : {};

  const t = useFormatMessage();
  const ariaLabel = t(intlMessages.ariaLabel);

  // Since we want this effect hook to also react to external position changes, we can't
  // pass it dependencies, and we need it to run on each render, so we disable de
  // exhaustive-deps eslint rule.
  //
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // If the container is not meant to be sticky, or if the container ref isn't yet
    // set, we don't do anything
    if (!sticky || !container) return;

    // In the case we reach this part of the code, this means that the container is
    // intended to be sticky, so we only make its stickyness depend on the enabling or
    // not of the styles in the browser. This allows CSS-less browser users to have the
    // plain content without display issues.
    const shouldBeSticky = !checkCssIsDisabled();

    if (isSticky !== shouldBeSticky) setIsSticky(shouldBeSticky);
  });

  return (
    <nav
      className="contributions-list-navigation position-sticky"
      style={style}
      ref={setContainer}
      role="navigation"
      aria-label={ariaLabel}
    >
      <ContributionsListFilters
        participativeModule={participativeModule}
        refetchFragment={ContributionsListWithNavigationFragment_participativeModule}
      />

      <Suspense fallback={<BoxSpinner />}>
        <ContributionsListNavigation
          participativeModule={participativeModule}
          scrollableContainer={container}
        />
      </Suspense>
    </nav>
  );
};

const ContributionsListNavigationWithFilters_participativeModule = graphql__b40200e610dd69d51294;

export default ContributionsListNavigationWithFilters;

const intlMessages = defineMessages({
  ariaLabel: {
    id: "participativeModule.contributionsList.navigation.ariaLabel",
    defaultMessage: "Sommaire des contributions"
  }
});
